<template>
  <div>
    <el-container>
      <el-aside width="150px" class="u-center-aside">
        <el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" :router="true">
          <el-menu-item :key="menu.path" :index="menu.path" v-for="(menu,index) of routerMenus">
            <template slot="title">
              <i :class="menu.icon" class="iconfont"></i>
              <span slot="title">{{ menu.label }}</span>
            </template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="u-center-main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import {mapState} from "vuex";

export default {
  name: "UCenter",
  data() {
    return {
      uCenter: {
        name: '',
        departmentId: '',
        password: {
          oldPwd: '',
          newPwd: '',
          confirmNewPwd: '',
        }
      },

      //超级管理员身份
      // superPower: false,
      //
      // //机构管理员
      // deptPower: false,
      //
      // unApproveMember: false,
      //
      // memberPower: false,
      //
      // systemPower: false,

      routerMenus: [
        {
          label: '我的信息',
          path: '/uCenter/myInfo',
          icon: 'icon-gerenziliao'
        }, {
          label: '登录密码',
          path: '/uCenter/password',
          icon: 'icon-mima1'
        }, {
          label: '邀请链接',
          path: '/uCenter/inviteList',
          icon: 'icon-lianjie'
        },
        // {
        //   label: '文章发布',
        //   path: '/uCenter/article',
        //   icon: 'icon-ziliaoshouce-xianxing',
        // },

        {
          label: '病例审核通知',
          path: '/uCenter/applyNotice',
          icon: 'icon-tongzhifankui',
        },
        {
          label: '查看机构',
          path: '/organization/list',
          icon: 'icon-zuzhijigou',
        },{
          label: '返回首页',
          path: '/dashboard',
          icon: 'icon-shouye',
        }
      ],
      lastMenuItem: {
        label: '返回首页',
        path: '/dashboard',
        icon: 'icon-shouye',
      },
    }
  },

  watch: {
    userPower: {
      immediate: true,

      handler(newVal) {
        // this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
        // this.memberPower = this.$store.state.userPowerStore.memberPower;
        // this.deptPower = this.$store.state.userPowerStore.deptPower;
        // this.systemPower = this.$store.state.userPowerStore.systemPower;
        // this.superPower = this.$store.state.userPowerStore.superPower;

        this.routerMenus = this.$options.data().routerMenus

      /*  if (newVal === "super-manager") {
          let deptMenu = this.routerMenus.find(item => {
            return item.path === '/organization/list'
          })
          let deptIndex = this.routerMenus.indexOf(deptMenu);
          this.routerMenus.push({
            label: '审核列表',
            path: '/uCenter/approve',
            icon: 'icon-shenhe',
          })

          this.routerMenus.push({
            label: '用户审批',
            path: '/user/approve',
            icon: 'icon-shenhe',
          })

          this.routerMenus.push({
            label: '用户管理',
            path: '/user/manage',
            icon: 'icon-shenhe',
          })
          this.routerMenus.push({
            label: '角色管理',
            path: '/user/role/manage',
            icon: 'icon-shenhe',
          })

          deptMenu.label = '维护机构'
          this.routerMenus.splice(deptIndex, 1, deptMenu)

          let item = this.routerMenus.find(item => {
            return item.path === this.lastMenuItem.path
          })

          this.routerMenus.splice(this.routerMenus.indexOf(item), 1)
          this.routerMenus.push(this.lastMenuItem)
        } else*/ if (newVal === "system-manager" || newVal === 'super-manager') {
          let deptMenu = this.routerMenus.find(item => {
            return item.path === '/organization/list'
          })
          let deptIndex = this.routerMenus.indexOf(deptMenu);
          if (newVal === "system-manager" || newVal === 'super-manager'){
            this.routerMenus.push({
              label: '审核列表',
              path: '/uCenter/approve',
              icon: 'icon-shenhe',
            })

            this.routerMenus.push({
              label: '用户审批',
              path: '/user/approve',
              icon: 'icon-shenhe',
            })

            this.routerMenus.push({
              label: '用户管理',
              path: '/user/manage',
              icon: 'icon-shenhe',
            })
            this.routerMenus.push({
              label: '角色管理',
              path: '/user/role/manage',
              icon: 'icon-shenhe',
            })
          }else {
            this.routerMenus.push({
              label: '用户审批',
              path: '/user/approve',
              icon: 'icon-shenhe',
            })

            this.routerMenus.push({
              label: '角色管理',
              path: '/user/role/manage',
              icon: 'icon-shenhe',
            })
          }


          deptMenu.label = '维护机构'
          this.routerMenus.splice(deptIndex, 1, deptMenu)

          let item = this.routerMenus.find(item => {
            return item.path === this.lastMenuItem.path
          })

          this.routerMenus.splice(this.routerMenus.indexOf(item), 1)
          this.routerMenus.push(this.lastMenuItem)
        }else if (newVal === 'department-manager'){
          let deptMenu = this.routerMenus.find(item => {
            return item.path === '/organization/list'
          })
          let deptIndex = this.routerMenus.indexOf(deptMenu);
          this.routerMenus.push({
            label: '审核列表',
            path: '/uCenter/approve',
            icon: 'icon-shenhe',
          })

          this.routerMenus.push({
            label: '用户管理',
            path: '/user/manage',
            icon: 'icon-shenhe',
          })

          deptMenu.label = '维护机构'
          this.routerMenus.splice(deptIndex, 1, deptMenu)

          let item = this.routerMenus.find(item => {
            return item.path === this.lastMenuItem.path
          })

          this.routerMenus.splice(this.routerMenus.indexOf(item), 1)
          this.routerMenus.push(this.lastMenuItem)
        } else if (newVal === 'unapprove-member') {
          this.routerMenus = [
            {
              label: '我的信息',
              path: '/uCenter/myInfo',
              icon: 'icon-gerenziliao'
            }, {
              label: '登录密码',
              path: '/uCenter/password',
              icon: 'icon-mima1'
            }
          ];
          this.routerMenus.push(this.lastMenuItem);
        }

      }
    },

    /*unApproveMember:{
      immediate: true,

      handler(newVal) {
        if (newVal){
          this.routerMenus = [
            {
              label: '我的信息',
              path: '/uCenter/myInfo',
              icon: 'icon-gerenziliao'
            }, {
              label: '登录密码',
              path: '/uCenter/password',
              icon: 'icon-mima1'
            }
          ];
          this.routerMenus.push(this.lastMenuItem);
        }
      }
    },

    memberPower:{
      immediate: true,
      handler(newVal) {
        this.routerMenus = this.$options.data().routerMenus
      }
    },

    isAdmin:{

      immediate: true,

      handler(newVal) {

        let deptMenu = this.routerMenus.find(item =>{
          return item.path === '/organization/list'
        })

        let deptIndex = this.routerMenus.indexOf(deptMenu);

        console.log("333")
        if (newVal && !this.superPower) {
          this.routerMenus = this.$options.data().routerMenus
          //省中医机构管理员方可显示
          this.routerMenus.push({
            label: '用户管理',
            path: '/user/manage',
            icon: 'icon-shenhe',
          })
          this.routerMenus.push({
            label: '角色管理',
            path: '/user/role/manage',
            icon: 'icon-shenhe',
          })

          this.routerMenus.splice(deptIndex,1,deptMenu)

          let item = this.routerMenus.find(item => {
            return item.path === this.lastMenuItem.path
          })

          deptMenu.label = '维护机构'
          this.routerMenus.splice(this.routerMenus.indexOf(item),1)
          this.routerMenus.push(this.lastMenuItem)

        } else {
          deptMenu.label = '查看机构'
          this.routerMenus.splice(deptIndex,1,deptMenu)
        }
      },
    },

    superPower:{

      immediate: true,

      handler(newVal) {
        this.routerMenus = this.$options.data().routerMenus

        let deptMenu = this.routerMenus.find(item =>{
          return item.path === '/organization/list'
        })

        let deptIndex = this.routerMenus.indexOf(deptMenu);

        if (newVal) {
          this.routerMenus.push({
            label: '审核列表',
            path: '/uCenter/approve',
            icon: 'icon-shenhe',
          })

          this.routerMenus.push({
            label: '用户审批',
            path: '/user/approve',
            icon: 'icon-shenhe',
          })

          this.routerMenus.push({
            label: '用户管理',
            path: '/user/manage',
            icon: 'icon-shenhe',
          })
          this.routerMenus.push({
            label: '角色管理',
            path: '/user/role/manage',
            icon: 'icon-shenhe',
          })

          deptMenu.label = '维护机构'
          this.routerMenus.splice(deptIndex,1,deptMenu)

          let item = this.routerMenus.find(item => {
            return item.path === this.lastMenuItem.path
          })

          this.routerMenus.splice(this.routerMenus.indexOf(item),1)
          this.routerMenus.push(this.lastMenuItem)

        } else {
          deptMenu.label = '查看机构'
          this.routerMenus.splice(deptIndex,1,deptMenu)
        }
      },
    },*/

  },

  mounted() {
    this.initData()
  },
  methods: {

    initData() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
        this.memberPower = this.$store.state.userPowerStore.memberPower;
        this.deptPower = this.$store.state.userPowerStore.deptPower;
        this.systemPower = this.$store.state.userPowerStore.systemPower
        this.superPower = this.$store.state.userPowerStore.superPower;
      })
      // this.findUserInfo();
    },

    goHome() {
      this.$router.push({
        path: "/dashboard"
      })
    },

    //查询当前用户的数据
    findUserInfo() {
      let token = cookie.getCookie("token");
      let that = this;
      http.post(window.config.api.baseUrl + '/eims-api/user/currLoginInfo', {
        token: token,
        data: {}
      }).then(response => {
        let userId = response.data.data.userId
        this.uCenter.name = userId
      });
    },

  },

  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower,
    }),
  }
}
</script>

<style scoped>

/deep/ .el-menu-vertical-demo:not(.el-menu--collapse) {
  height: calc(100% - 69px);
  overflow: auto;
}

.u-center-aside {
  position: fixed;
  z-index: 80;
  height: 100%;

}

.u-center-main {
  margin-left: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/UCenter.vue